import { render, staticRenderFns } from "./BirIsinYapilmasiVeyaYapilmamasiAlacakKalemiForm.vue?vue&type=template&id=9c904f20"
import script from "./BirIsinYapilmasiVeyaYapilmamasiAlacakKalemiForm.vue?vue&type=script&lang=ts"
export * from "./BirIsinYapilmasiVeyaYapilmamasiAlacakKalemiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports